<div class="container">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <div class="mt-3">
    <h4>Revise seus dados cadastrais</h4>
  </div>
  
  @if (exibicao(); as dados) {
    <div class="dados-cadastrais">
      <div>
        <table>
          <tbody>
            <tr>
              <td>Nome:</td>
              <td class="text-right">{{ dados.nome }}</td>
            </tr>
            <tr>
              <td>CPF:</td>
              <td class="text-right">{{ dados.cpf }}</td>
            </tr>
            <tr>
              <td>Matrícula:</td>
              <td class="text-right">{{ dados.matricula }}</td>
            </tr>
            <tr>
              <td>Opção:</td>
              <td class="text-right">{{ dados.opcao }}</td>
            </tr>
            <tr>
              <td>Imposto de Renda:</td>
              <td class="text-right">{{ dados.regime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table>
          <tbody>
            <tr>
              <td>Banco:</td>
              <td class="text-right">{{ dados.banco }}</td>
            </tr>
            <tr>
              <td>Agência:</td>
              <td class="text-right">{{ dados.agencia }}</td>
            </tr>
            <tr>
              <td>Conta:</td>
              <td class="text-right">{{ dados.conta }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  
    <div class="detalhes top-64">
      <p>Detalhes do seu resgate</p>
      <table>
        <tbody>
          <tr>
            <td>Número de parcelas:</td>
            <td class="text-right">{{ dados.numeroParcelas }} Parcela(s)</td>
          </tr>
          <tr>
            <td>Valor da primeira parcela:</td>
            <td class="text-right">{{ dados.valorPrimeiraParcela }}</td>
          </tr>
          <tr>
            <td>Valor Bruto do Resgate:</td>
            <td class="text-right">{{ dados.valorBruto }}</td>
          </tr>
          <tr>
            <td>Valor do Imposto de Renda (estimado):</td>
            <td class="text-right red">{{ dados.valorIR }}</td>
          </tr>
          <tr class="valor-resgate">
            <td>Valor Líquido do Resgate (estimado):</td>
            <td class="text-right"><span class="moeda">R$</span> {{ dados.valorLiquido }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  
  <div class="d-flex justify-content-center align-items-center buttons top-64">
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
    <vivest-button variant="primary" size="md" (click)="onSubmit()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Continuar para assinatura do termo
    </vivest-button>
  </div>
</div>
